<template>
  <base-wrapper>
    <edit-office-form office-type="stockist_center" :disabled-fields="['code']" :office-id="$route.params.id" @success="$router.push({ name: 'master.stockist-center' })" />
  </base-wrapper>
</template>
<script>
import EditOfficeForm from '@/components/office/edit-office-form.vue';

export default {
  name: 'EditStockistCenter',
  components: {
    EditOfficeForm,
  },
};
</script>
